var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(22.5px,22.5px); } 25% { transform: translate(41.5px,22.5px); } 50% { transform: translate(41.5px,41.5px); } 75% { transform: translate(22.5px,41.5px); } 100% { transform: translate(22.5px,22.5px); } }\n@keyframes a1_t { 0% { transform: translate(41.5px,22.5px); } 25% { transform: translate(41.5px,41.5px); } 50% { transform: translate(22.5px,41.5px); } 75% { transform: translate(22.5px,22.5px); } 100% { transform: translate(41.5px,22.5px); } }\n@keyframes a2_t { 0% { transform: translate(41.5px,41.5px); } 25% { transform: translate(22.5px,41.5px); } 50% { transform: translate(22.5px,22.5px); } 75% { transform: translate(41.5px,22.5px); } 100% { transform: translate(41.5px,41.5px); } }\n@keyframes a3_t { 0% { transform: translate(22.5px,41.5px); } 25% { transform: translate(22.5px,22.5px); } 50% { transform: translate(41.5px,22.5px); } 75% { transform: translate(41.5px,41.5px); } 100% { transform: translate(22.5px,41.5px); } }\n    ")), /*#__PURE__*/React.createElement("ellipse", {
    fill: "rgba(0,0,0,0.30)",
    rx: 3.5,
    ry: 3.5,
    transform: "translate(22.5,22.5)",
    style: {
      animation: "2s linear infinite both a0_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "rgba(0,0,0,0.10)",
    rx: 3.5,
    ry: 3.5,
    transform: "translate(41.5,22.5)",
    style: {
      animation: "2s linear infinite both a1_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "rgba(0,0,0,0.30)",
    rx: 3.5,
    ry: 3.5,
    transform: "translate(41.5,41.5)",
    style: {
      animation: "2s linear infinite both a2_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "rgba(0,0,0,0.10)",
    rx: 3.5,
    ry: 3.5,
    transform: "translate(22.5,41.5)",
    style: {
      animation: "2s linear infinite both a3_t"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.7e02c031cd328abc346c9838d4b746ec.svg";
export { ForwardRef as ReactComponent };